import React from 'react';

const socialLinks = [
  {
    name: 'Instagram',
    url: 'https://instagram.com/justinshamoka',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
      </svg>
    ),
  },
  {
    name: 'Facebook',
    url: 'https://facebook.com/justinshamokaphotos',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    url: 'https://linkedin.com/in/justinshamoka',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
        <rect x="2" y="9" width="4" height="12"></rect>
        <circle cx="4" cy="4" r="2"></circle>
      </svg>
    ),
  },
  {
    name: 'X (Twitter)',
    url: 'https://x.com/juic3b0x52',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 4l11.733 16h4.267l-11.733 -16z"></path>
        <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"></path>
      </svg>
    ),
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="container footer__container">
        <div className="footer__brand-col">
          <a href="/" className="footer__logo-wrap" aria-label="Justin Shamoka Photography Home">
            <img
              src="/assets/PNG/shamoka-logo-large-horiz-whitte.png"
              alt="Justin Shamoka Photography"
              className="footer__wordmark-img"
            />
          </a>
          <p className="footer__tagline">
            Capturing authentic light, genuine emotions, and timeless visual stories.
          </p>
          <div className="footer__socials">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn"
                aria-label={`Visit Justin Shamoka on ${social.name}`}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__nav-col">
          <span className="footer__heading">Navigation</span>
          <ul className="footer__list">
            <li><a href="#services" className="footer__link">Services</a></li>
            <li><a href="#portfolio" className="footer__link">Portfolio</a></li>
            <li><a href="#about" className="footer__link">About</a></li>
            <li><a href="#contact" className="footer__link">Book Session</a></li>
          </ul>
        </div>

        <div className="footer__contact-col">
          <span className="footer__heading">Inquiries</span>
          <p className="footer__info">Serving Oakville and the Greater Toronto Area.</p>
          <a href="mailto:info@justinshamoka.photos" className="footer__email">
            info@justinshamoka.photos
          </a>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {currentYear} Justin Shamoka Photography. All rights reserved.</p>
          <div className="footer__legal">
            <a href="#privacy" className="footer__legal-link">Privacy Policy</a>
            <span>•</span>
            <a href="#terms" className="footer__legal-link">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;